import { SEO } from "@/components/SEO";
import logoTupja from "@/assets/logo-tupja.png";
import { MessageCircle, Instagram } from "lucide-react";

const WHATSAPP_NUMBER = "14077758479";
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;
const INSTAGRAM_URL = "https://www.instagram.com/terreiropaijoaquimdearuanda";


const Index = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "TUPJA - Terreiro Pai Joaquim de Aruanda",
    "url": window.location.origin,
    "logo": `${window.location.origin}/logo-tupja.png`,
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "Customer Service",
      "telephone": "+1-407-775-8479",
      "availableLanguage": ["Portuguese", "English"]
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-logo-brown-dark via-logo-brown to-logo-gray p-6 text-center">
      <SEO
        title="Atendimentos via WhatsApp"
        description="Nossos atendimentos estão sendo realizados exclusivamente pelo WhatsApp. Entre em contato conosco."
        keywords="tupja, terreiro pai joaquim de aruanda, umbanda, whatsapp, atendimento"
        structuredData={structuredData}
      />
      
      <div className="max-w-xl w-full bg-white/10 backdrop-blur-md rounded-3xl p-8 md:p-12 shadow-2xl border border-white/20">
        <div className="mb-8">
          <img
            src={logoTupja}
            alt="TUPJA - Terreiro Pai Joaquim de Aruanda"
            className="w-40 h-40 md:w-56 md:h-56 object-contain mx-auto drop-shadow-2xl"
          />
        </div>

        <h1 className="font-display text-3xl md:text-5xl text-logo-beige mb-6 font-bold">
          Atendimentos via WhatsApp
        </h1>

        <p className="font-body text-lg md:text-xl text-white/90 leading-relaxed mb-8">
          Por enquanto, nossos atendimentos estão sendo realizados exclusivamente pelo WhatsApp.
          Clique no botão abaixo para falar conosco.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-8 py-4 bg-[#25D366] hover:bg-[#128C7E] text-white font-bold text-lg md:text-xl rounded-full transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105"
          >
            <MessageCircle className="w-7 h-7" />
            Falar no WhatsApp
          </a>

          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-[#833AB4] via-[#E1306C] to-[#F77737] hover:opacity-90 text-white font-bold text-lg md:text-xl rounded-full transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105"
          >
            <Instagram className="w-7 h-7" />
            Instagram
          </a>
        </div>

        <p className="mt-6 text-white/70 font-sans text-sm">
          {WHATSAPP_NUMBER}
        </p>


        <div className="mt-10 pt-8 border-t border-white/20">
          <p className="font-display text-2xl text-logo-beige font-bold mb-1">
            TUPJA
          </p>
          <p className="text-white/60 text-sm font-sans">
            Terreiro Pai Joaquim de Aruanda
          </p>
        </div>
      </div>
    </div>
  );
};

export default Index;
